export default {
  SET_LISTA_PAYMENT_CONFIGS(state, payload) {
    state.listaPaymentConfigs = payload
  },
  SET_PAYMENT_CONFIG(state, payload) {
    state.paymentConfig = payload
  },
  RESET_PAYMENT_CONFIG(state) {
    state.paymentConfig = {
      id: null,
      registroId: null,
      formaPagamento: null,
      conta: null,
      tipoPagamento: null,
      principal: true
    }
  }
}
